import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { unFormatCurrency, unFormatUnknownUnit } from '@/common/utils/unFormatters';
import { DiagnosticObjectivePieceValidationSchema } from '../../schemas/diagnosticObjectivePiece.schema';

interface UseCreateDiagnosticObjectivePieceProps {
  diagnosticObjectiveId: string | undefined;
  pieceId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    DiagnosticObjectivePieceValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useCreateDiagnosticObjectivePiece = ({
  diagnosticObjectiveId,
  pieceId,
  options,
}: UseCreateDiagnosticObjectivePieceProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createDiagnosticObjectivePiece'],
    mutationFn: (form) => {
      const payload = {
        diagnostic_objective_id: diagnosticObjectiveId,
        piece_id: pieceId,
        description: form.description,
        unit_price: form.unit_price && unFormatCurrency(form.unit_price),
        quantity: form.quantity && unFormatUnknownUnit(form.quantity),
        warranty_in_days: form.warranty_in_days && unFormatUnknownUnit(form.warranty_in_days),
      }

      return privateAxios.post(`/maintenance/diagnostic_objective_pieces`, {
        ...payload,
      });
    },
    ...options
  });
}
